 export const TOGGLE_MODAL_SOUND = "TOGGLE_MODAL_SOUND",
             SELECT_LANG = "SELECT_LANG",
             SET_START_TIME = "SET_START_TIME",
             SET_END_TIME = "SET_END_TIME",
             INIT_ANSWERS = "INIT_ANSWERS",
             RESET_ANSWERS = "RESET_ANSWERS",
             SET_ANSWERS = "SET_ANSWERS";
